import { useCallback } from 'react';
import { useClient } from 'hooks/useClient';
import { useMutation } from 'react-query';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { ERROR_TOAST_DEFAULTS, SUCCESS_TOAST_DEFAULTS } from '@helpers';
import { useToast } from '@chakra-ui/react';
import { translations } from 'translations';
import { useTranslation } from 'react-i18next';
import { useSession } from 'store/session';
import { AxiosError } from 'axios';

export const useDeleteInvite = ({ token }) => {
  const client = useClient({
    token: resolveTokenV3(token),
    url: process.env.REACT_APP_API_V3,
  });

  const toast = useToast();

  const { team } = useSession();

  const { t } = useTranslation();

  const teamUUID = team?.uuid as string;

  const onError = useCallback(
    (error: AxiosError) => {
      let msg = t(translations.ERRORS.NETWORK_DEFAULT);
      if (error?.response?.status === 403) {
        msg = t(translations.DOCUMENT_PAGES.INVITE_DELETE_403);
      }
      toast({ ...ERROR_TOAST_DEFAULTS, title: msg });
    },
    [t, toast],
  );

  const mutation = useMutation(
    'delete-invite',
    async ({ team, folder, document, invite }: any) => {
      await client.deletehDocumentInvitationByIdV3(
        team ?? teamUUID,
        folder,
        document,
        invite,
      );

      const MESSAGE = t(translations.DOCUMENT_PAGES.INVITE_DELETE_SUCCESS);

      toast({ ...SUCCESS_TOAST_DEFAULTS, title: MESSAGE });
    },
    { onError },
  );

  return { ...mutation };
};
